import { apiRequest } from "util/services";

export async function fetchDashboardReviewTrendsBatch(dashboardIds, userId) {
  const ids = Array.from(
    new Set(
      (dashboardIds || [])
        .map((id) => parseInt(id, 10))
        .filter((id) => Number.isFinite(id) && id > 0),
    ),
  );
  if (!ids.length) {
    return {};
  }
  const payload = { dashboard_ids: ids };
  if (userId) {
    payload.user_id = userId;
  }
  const result = await apiRequest(
    "dashboards/review-trends/batch",
    "POST",
    payload,
    true,
  );
  if (result?.error || !result?.trends) {
    return {};
  }
  return result.trends;
}
